import graphqlRequest from "../skillsMasteryRequest";
import GET_SKILL_RESOURCES from "./getSkillResourcesGraphql";

export async function getSkillResources(skillId, studentId, limit, filter) {
  let inputs = {
    skillId,
    studentId,
    limit,
    filter: filter || {}
  };

  return await graphqlRequest(GET_SKILL_RESOURCES, inputs);
}

/**
 * Bulk fetch skill resources for multiple skills using a single meta-query with skillId aliases.
 * @param {string[]} skillIds
 * @param {number} limit
 * @returns {Promise<{ [skillId: string]: AmiraResources[] }>} (dictionary by skillId)
 */
export async function getSkillResourcesMulti(skillIds, district, school, limit = 5, filter={}) {
  // Build alias queries for each skillId
  const aliasMap = {};
  const aliasQueries = [];
  const preparedFilter = Object.entries(filter).map(([k,v]) => `${k}: ${JSON.stringify(v)}`).join(', ');

  for (const skillId of skillIds) {
    // Only allow valid GraphQL alias characters: letters, numbers, underscores
    const safeSkillId = String(skillId).replace(/[^a-zA-Z0-9_]/g, '_');
    const alias = safeSkillId;
    aliasMap[alias] = skillId;    
    aliasQueries.push(`
      ${alias}: skillResources(skillId: "${skillId}", studentId: "-1", districtId: "${district}", schoolId: "${school}", limit: ${limit}, filter:{${preparedFilter}}
      ){
        resources {
          label
          resourceUniqueId
          resourceType
          provider
          tags
          storyIds
        }
      }
    `);
  }
  const query = `query GetSkillResourcesMulti {\n${aliasQueries.join('\n')}\n}`;
  // console.log(`----====> (getSkillResourcesMulti) query`, query);
  let response;
  try {
    response = await graphqlRequest(query, {});
  } catch (error) {
    return {};
  }

  // Parse the response into the desired mapping
  const results = {};
  
  // Map using the original skill ID as the key (which is what the calling code expects)
  for (const alias in aliasMap) {
    const originalSkillId = aliasMap[alias];
    const resources = response?.[alias]?.resources || [];
    // Use the original skill ID as the key (which is what the calling code expects)
    results[originalSkillId] = resources;
  }
  
  // If no results found, try mapping using the original skillIds directly
  if (Object.keys(results).length === 0) {
    for (const skillId of skillIds) {
      const resources = response?.data?.[skillId]?.resources || [];
      results[skillId] = resources;
    }
  }
  return results;
}
